/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Range_3_MonthsInputs */

const en_dashboard_range_3_months = /** @type {(inputs: Dashboard_Range_3_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 3 months`)
};

const pt_br2_dashboard_range_3_months = /** @type {(inputs: Dashboard_Range_3_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos 3 meses`)
};

/**
* | output |
* | --- |
* | "Last 3 months" |
*
* @param {Dashboard_Range_3_MonthsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_range_3_months = /** @type {((inputs?: Dashboard_Range_3_MonthsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Range_3_MonthsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_range_3_months(inputs)
	return pt_br2_dashboard_range_3_months(inputs)
});